<template>
  <div>
    <b-modal :id="id" centered size="lg" @show="showModalActivacioEnquesta" @ok="handleSubmitActivacioEnquesta" @hidden="hideModalActivacioEnquesta" :title='$t("admin.enquestes.activacio.titol")'>
      <b-form ref="formActivacioEnquesta" @submit.stop.prevent="handleSubmit">
      <b-form-group
        id="input-group-1"
        :label='$t("admin.enquestes.activacio.descripcio")+":"' label-size="sm"
        label-for="input-1" label-cols="4" label-cols-lg="2"
      >
        <b-form-input
          id="input-1" 
          v-model="formActivacio.descripcio"
          type="text"
          required size="sm"
          :placeholder='$t("admin.enquestes.activacio.descplaceholder")'
        ></b-form-input>
      </b-form-group>

    <b-form-group
      label-cols="4" label-cols-lg="2"
      :label='$t("admin.enquestes.activacio.expiracio")+":"' label-size="sm"
    >
    <b-input-group>
      <b-form-group class="group-data-expiracio mb-0 mr-2"
        label-cols-sm="0"
        label=""
        label-for="input-5" 
        description="" 
      >      
        <b-form-input size="sm" id="input-5" v-model="formActivacio.dataExpiracio" type="date" @update="onUpdateDataExpiracio"></b-form-input>              
      </b-form-group>      

      <b-form-group class="group-dies-expiracio mb-0 mr-2"
        label-cols-sm="0"
        label=""
        label-for="input-6"
        description="" 
      >
      <b-input-group size="sm" append="dies">      
        <b-form-input size="sm" id="input-6" v-model="formActivacio.diesExpiracio" type="number" @update="onUpdateDiesExpiracio"></b-form-input>
      </b-input-group>        
      </b-form-group>
      <span class="m-1" id="tooltip-dies-expiracio"><b-icon variant="primary" icon="question-circle"></b-icon></span>
      <b-tooltip target="tooltip-dies-expiracio">{{$t("admin.enquestes.activacio.expiraciotooltip")}}</b-tooltip>

    </b-input-group>

    </b-form-group>

    <b-form-group
      id="input-group-4"
      label-cols="4" label-cols-lg="2" label-size="sm"
      description="" 
      :label='$t("admin.enquestes.activacio.recordatori")+":"'
      label-for="input-4"
    >
    <b-input-group>
    <b-input-group size="sm" append="dies" class="group-dies-recordatori"> 
      <b-form-input size="sm" id="input-4" v-model="formActivacio.enviamentRecordatori" type="number" @update="onUpdateDiesRecordatori"></b-form-input>
    </b-input-group>
    <span class="m-1" id="tooltip-dies-recordatori"><b-icon variant="primary" icon="question-circle"></b-icon></span>
    <b-tooltip target="tooltip-dies-recordatori">{{$t("admin.enquestes.activacio.recordatoritooltip")}}</b-tooltip>
    </b-input-group>
    </b-form-group>    

    <b-form-group
      id="input-group-5"
      :label='$t("admin.enquestes.activacio.margeRecordatori")+":"' label-size="sm"
      label-for="input-5" label-cols="4" label-cols-lg="2"
    >
      <b-form-input
        id="input-5" 
        v-model="formActivacio.margeRecordatori"
        type="number"
        size="sm"
      ></b-form-input>
    </b-form-group>
      </b-form>      
    </b-modal>
  </div>
</template>

<script>
import enquestaService from "../../services/EnquestaService";
export default {
  name: "ModalActivacioEnquesta",
  props: {
    id: {
      type: String,
      required: true
    },
    activacio:{
      type: Object,
      required: true
    }
  },  
  data() {
    return {
      formActivacio:{}
    };
  },  
  methods: {
    showModalActivacioEnquesta() { 

      this.formActivacio = this.emptyForm();
      this.formActivacio.idEnquesta = this.activacio.idEnquesta;
      if(this.activacio.idActivacio){            
            this.formActivacio.idActivacio = this.activacio.idActivacio;
            this.formActivacio.descripcio = this.activacio.descripcio;          
            this.formActivacio.dataExpiracio = this.activacio.dataExpiracio;
            this.formActivacio.diesExpiracio = this.activacio.diesExpiracio;
            this.formActivacio.margeRecordatori = this.activacio.margeRecordatori;
            this.formActivacio.enviamentRecordatori = this.activacio.enviamentRecordatori;       
      }

    },
    handleSubmitActivacioEnquesta(bvModalEvt) {     
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      
      enquestaService.saveActivacioEnquesta(this.formActivacio).then(response => {        

        this.$emit('activacio-editada', response.data)
        this.hideModalActivacioEnquesta();

        })
        .catch(e => {
          console.log(e);
      });
     
    },
    emptyForm(){
        return {
          idEnquesta:null,
          idActivacio:null,
          descricpcio:null,
          enviamentRecordatori:null,
          diesExpiracio:null,
          dataExpiracio:null}
    },
    hideModalActivacioEnquesta(bvModalEvt) {      
      // Prevent modal from closing
      if(bvModalEvt){bvModalEvt.preventDefault();} 
      
      // Reset our form values
      this.formEnquesta = this.emptyForm();

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.id)
      })       

    },
    checkFormValidity() {
      const valid = this.$refs.formActivacioEnquesta.checkValidity();    
      return valid
    },     
    onUpdateDataExpiracio(value){
      if(value){
            this.formActivacio.diesExpiracio = null;
          if(new Date(value).valueOf() < new Date().valueOf()){
            this.$nextTick(() => {              
              this.formActivacio.dataExpiracio = this.getDataActual(0);
            })
          }
          
      }
      this.$nextTick(() => {      
        this.checkDiesRecordatori();
      })
    }, 
    onUpdateDiesExpiracio(value){
      if(value){
        if(value<1){  
          this.$nextTick(() => {
            this.formActivacio.diesExpiracio = 0;
          })   
        }else{
          this.formActivacio.dataExpiracio = null;
        }
      }
      this.$nextTick(() => {      
        this.checkDiesRecordatori();
      })            
    }, 
    onUpdateDiesRecordatori(value){
      if(value){
        if(value<1){  
          this.$nextTick(() => {
            this.formActivacio.enviamentRecordatori = 0;
          })   
        }
      }else{
        this.$nextTick(() => {
          this.formActivacio.enviamentRecordatori = 0;
        }) 
      }
      this.$nextTick(() => {      
        this.checkDiesRecordatori();
      })       
    }, 
    checkDiesRecordatori(){
      if(!(this.formActivacio.enviamentRecordatori > 0)){
        return;
      }
      if(this.formActivacio.diesExpiracio && this.formActivacio.diesExpiracio>=0 && this.formActivacio.enviamentRecordatori>=this.formActivacio.diesExpiracio){        
        this.formActivacio.enviamentRecordatori = this.formActivacio.diesExpiracio;
      }
      if(this.formActivacio.dataExpiracio){
          let d = this.getDataActual(this.formActivacio.enviamentRecordatori);
           while(new Date(this.formActivacio.dataExpiracio).valueOf() < new Date(d).valueOf()){
            this.formActivacio.enviamentRecordatori = this.formActivacio.enviamentRecordatori-1;
            d = this.getDataActual(this.formActivacio.enviamentRecordatori);
           }
      }
    },
    getDataActual(offsetDies){      
      let now = new Date(new Date().getTime()+offsetDies*24*60*60*1000);
      return now.getFullYear()+'-'+("0" + (now.getMonth()+1)).slice(-2)+'-'+("0" + now.getDate()).slice(-2);      
    }       
  },
  mounted() {}
};
</script>

<style>
.group-data-expiracio{
  width: 150px;
}
.group-dies-expiracio{
  width: 120px;
}
.group-dies-recordatori{
  width: 120px;
}
</style>